"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.candidatesViewModel = candidatesViewModel;
const candidate_1 = require("./candidate");
function candidatesViewModel(candidates, personsMap, organizationsMap, baseUrl) {
    return candidates.map((candidate) => (0, candidate_1.candidateViewModel)(candidate, personsMap, organizationsMap, baseUrl));
}
